module.exports = __webpack_public_path__ + "img/bgc2.ee45f99d.jpg";